import $i18n from "@/utils/i18n"

export const state = {
  language: "en",
};

export const actions = {
  setLanguageAction({ commit }, data) {
    commit("setLanguage", data);
  },
};

export const mutations = {
  setLanguage(state, data) {
    $i18n.locale = data;
    state.language = data;
  },
};

export const getters = {
  getLanguage(state) {
    return state.language;
  },
};